import { useContext } from 'react';
import { ThemeContext } from '@/contexts/ThemeContext';
import { ThemeContextType } from '@/types';

/**
 * useTheme Hook
 *
 * Provides convenient access to theme/branding context
 *
 * @throws Error if used outside ThemeProvider
 * @returns ThemeContextType
 *
 * @example
 * const { branding, isLoading, refreshBranding } = useTheme();
 */
export const useTheme = (): ThemeContextType => {
  const context = useContext(ThemeContext);

  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }

  return context;
};
